export default {
    init() {
        $(".password-toggle").on("click", ".password-icon", function () {
            const $icon = $(this).find("i")
            const $input = $(this).closest(".password-toggle").find("input[type='password'], input[type='text']")
            const isVisible = $icon.hasClass("dashicons-visibility")


            $icon.toggleClass("dashicons-visibility", !isVisible).toggleClass("dashicons-hidden", isVisible)

            $input.attr("type", isVisible ? "text" : "password")
        })
    }
}